exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-info-label[data-v-1eb7ca44] {\n  font-weight: 600;\n}\n.user-revoked-card[data-v-1eb7ca44] {\n  background-color: rgba(220, 53, 69, 0.1) !important;\n}\n.user-approved-card[data-v-1eb7ca44] {\n  background-color: rgba(40, 167, 69, 0.1) !important;\n}\na label[data-v-1eb7ca44]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1eb7ca44","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/user-registration/user-approval/UserApproval.vue
// module id = 662
// module chunks = 1